import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { StoreProvider } from "@/context/StoreContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Terms from "@/pages/Terms";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <StoreProvider>
      <BrowserRouter>
        <div className="App text-slate-100">
          <div className="noise-overlay" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/subscription" element={<Navigate to="/" replace />} />
            <Route path="/product/subscription" element={<Navigate to="/" replace />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/vilkar" element={<Terms />} />
          </Routes>
          <Toaster position="top-center" theme="dark" richColors />
        </div>
      </BrowserRouter>
    </StoreProvider>
  );
}

export default App;
